import { Navigate, Outlet } from "react-router-dom";


const AuthLayout = () => {
    const token = localStorage.getItem("token");

    if (token) {
        return <Navigate to="/" replace />;
    }

    return (
        <div style={{ minHeight: "100vh" }}>
            <Outlet />
        </div>
    );
};
export default AuthLayout;